export default "__VITE_ASSET__4d092a7f__"